import { useState } from 'react';
import classNames from 'classnames';
import { Checkbox, Spinner } from '@schibsted-svp/react-ui';

import type { ChangeEvent, FC } from 'react';

import styles from './UpdatingCheckbox.module.scss';

type Props = {
  value?: boolean;
  onChange: (value: boolean) => Promise<void> | void;
  disabled?: boolean;
  label?: string;
};

const UpdatingCheckbox: FC<Props> = ({ value, onChange, disabled, label }) => {
  const [isUpdating, setIsUpdating] = useState(false);

  async function update(value: boolean) {
    setIsUpdating(true);

    await onChange(value);

    setIsUpdating(false);
  }

  return (
    <div
      className={classNames(styles.container, {
        [styles.isUpdating]: isUpdating,
      })}
    >
      <Spinner size={'small'} className={styles.spinner} />
      <Checkbox
        label={label}
        checked={value}
        onChange={async (event: ChangeEvent<HTMLInputElement>) => {
          const value = event.currentTarget.checked;

          await update(value);
        }}
        disabled={disabled || isUpdating}
        className={styles.checkbox}
      />
    </div>
  );
};

export { UpdatingCheckbox };
